/******************************************************************************
 * Created Date: Wednesday Febuary 16th 2022                                  *
 * Author: Jan A.                                                             *
 * -----                                                                      *
 * Last Modified: Thu Feb 17 2022                                             *
 * Modified By: Jan A.                                                        *
 * -----                                                                      *
 * File: /src/components/account/Users/components/List/Utils/MakeColumns.jsx  *
 * Copyright (c) 2021 Kuva                                                    *
 ******************************************************************************/

import PropTypes from "prop-types";
import { Avatar, IconButton } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";

function MakeColumns({ onClickEdit }) {
  return [
    {
      field: "picture",
      headerName: " ",
      width: 70,
      sortable: false,
      filterable: false,
      hideSortIcons: true,
      renderCell: ({ value }) => (
        <Avatar
          style={{
            height: "50px",
            width: "50px"
          }}
          src={value}
        />
      )
    },
    { field: "name", headerName: "Name", width: 180, editable: false },
    { field: "email", headerName: "Email", width: 180, editable: false },
    {
      field: "roles",
      headerName: "Role",
      width: 120,
      type: "singleSelect",
      editable: false,
      valueGetter: ({ row }) => row.app_metadata?.roles?.[0],
      valueFormatter: ({ value }) =>
        value ? value[0].toUpperCase() + value?.slice(1) : "None"
    },
    {
      field: "last_login",
      width: 160,
      headerName: "Last Login",
      description: "The last time this user logged into the system.",
      valueGetter: ({ value }) => (value ? new Date(value) : "Never"),
      type: "dateTime"
    },
    {
      field: "last_password_reset",
      width: 180,
      headerName: "Last Pass Reset",
      description: "The last time this user changed their password.",
      valueGetter: ({ value }) => (value ? new Date(value) : "Never"),
      type: "date"
    },
    {
      field: "actions",
      headerName: "Edit",
      width: 80,
      sortable: false,
      filterable: false,
      renderCell: row => (
        <IconButton size="small" onClick={() => onClickEdit(row)}>
          <EditIcon size="small" />
        </IconButton>
      )
    }
  ];
}

MakeColumns.propTypes = {
  onClickEdit: PropTypes.func.isRequired
};

export default MakeColumns;
